import { z } from "zod";
import { getIdSchema, ID, makeIdGenerator } from "../utils";

export const harvestDataIdPrefix = "har_";
export type HarvestDataId = ID<typeof harvestDataIdPrefix>;
export const generateHarvestDataId = makeIdGenerator(harvestDataIdPrefix);
export const harvestDataIdSchema = getIdSchema(
  harvestDataIdPrefix,
  "HarvestDataId",
);

export const harvestDataSchema = z
  .object({
    id: harvestDataIdSchema,
    time: z.coerce.date(),
    data: z.unknown(),
    metadata: z.unknown(),
  })
  .meta({ id: "HarvestData" });

export type HarvestData = z.infer<typeof harvestDataSchema>;
